export interface SupplierOrderAllocationDimensionSource {
  unit?: string | null;
  width?: number | string | null;
  length?: number | string | null;
  height?: number | string | null;
  thickness?: number | string | null;
}

export interface SupplierOrderAllocationItemOption extends SupplierOrderAllocationDimensionSource {
  value: string | number;
  label: string;
}

export const buildSupplierOrderAllocationItemOption = (
  item: SupplierOrderAllocationDimensionSource,
  value: string | number,
  label: string,
): SupplierOrderAllocationItemOption => ({
  value,
  label,
  unit: item.unit,
  width: item.width,
  length: item.length,
  height: item.height,
  thickness: item.thickness,
});
